import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Typography, Box } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

// ✅ COMPONENTE SEPARADO PARA EL MODAL DE URL
const UrlModalContent = ({ onAdd, onClose, loading, classes }) => {
    const [url, setUrl] = React.useState("");
    const [caption, setCaption] = React.useState("");

    const handleSubmit = () => {
        if (url && url.trim()) {
            onAdd(url.trim(), caption.trim() || null);
            setUrl("");
            setCaption("");
        }
    };

    return (
        <>
            <DialogContent className={classes.dialogContent}>
                <TextField
                    label={i18n.t("promptModal.urlDialog.urlLabel")}
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    className={classes.formField}
                    placeholder={i18n.t("promptModal.urlDialog.urlPlaceholder")}
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleSubmit();
                        }
                    }}
                />
                <TextField
                    label={i18n.t("promptModal.urlDialog.captionLabel")}
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    className={classes.formField}
                    placeholder={i18n.t("promptModal.urlDialog.captionPlaceholder")}
                    multiline
                    rows={2}
                    value={caption}
                    onChange={(e) => setCaption(e.target.value)}
                />
                <Box className={classes.infoBox} style={{ marginTop: 16 }}>
                    <Typography className={classes.infoText} style={{ fontSize: "12px" }}>
                        {i18n.t("promptModal.urlDialog.hintPublic")}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    onClick={onClose}
                    className={classes.cancelButton}
                >
                    {i18n.t("promptModal.urlDialog.close")}
                </Button>
                <Button
                    onClick={handleSubmit}
                    className={classes.saveButton}
                    disabled={loading || !url.trim()}
                >
                    {i18n.t("promptModal.urlDialog.add")}
                </Button>
            </DialogActions>
        </>
    );
};

export default UrlModalContent;
